<template>
  <div class="retailOrderPay" >
    <XR-Result icon="fa fa-yes2" msg="支付成功" content="恭喜您，订单已支付成功" ></XR-Result>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/shangquan/sqPaySuccess.vue